import { useCallback, useContext } from 'react';
import { ProductTableContext } from '../../../contexts/product-table-context';
import type { Filters } from '../../../hooks/products';
import { StoreLabelsInput } from '../../products/store-labels-input';
import { withFilterField } from './filter-component';
import { FilterWrapper } from './filter-wrapper';

export const LabelFilter = withFilterField('labelIds', function LabelFilter() {
  const { filters, setFilters } = useContext(ProductTableContext);
  const { labelIds = [] } = filters;

  const onChange = useCallback(
    (newLabelIds: number[]) => {
      setFilters((prev: Filters) => ({
        ...prev,
        labelIds: newLabelIds,
      }));
    },
    [setFilters]
  );

  return (
    <FilterWrapper label="Label">
      <StoreLabelsInput value={labelIds} onChange={onChange} />
    </FilterWrapper>
  );
});
